/**
 * The one wire between the statement engine's snapshots and the rest of the app.
 *
 * Same contract as tax-bridge.js, for the same reason: statement snapshots live in their own
 * IDB key and never enter S. The watchdog (`cashflow.statementMismatch`) needs four facts per
 * card - which card, which cut, which Monthly month it is due in, and the bank's total - and
 * it must not import the statements module (the render loop, cashflow and the DOM) to ask.
 *
 * NO IMPORTS, NO STATE WRITES, NO NETWORK.
 *
 * NULL IS NOT EMPTY. `null` means nobody has read the snapshots yet; `[]` means the store was
 * read and there are none. An install with no statement engine must not carry a permanent
 * warning, and an unread store must not report a clean month.
 */

let _facts = null;

/**
 * Called by the statements module every time its snapshot set changes, with the NEWEST
 * statement per card: `[{ card, cut, due_month, total_due, generated, status }]`.
 */
export function publishStatements(list) {
  _facts = Array.isArray(list) ? list.slice() : null;
}

/** @returns {Array|null} newest statement per card, or null if the snapshots have not been read. */
export function statementsSeen() {
  return _facts;
}

/** Test seam. */
export function _resetStatements() {
  _facts = null;
}
